<script setup lang="ts">
import { DialogContent, DialogOverlay, DialogPortal, DialogRoot, DialogTitle } from 'reka-ui'
import Logo from './Logo.vue'
import NavList from './NavList.vue'

const open = defineModel<boolean>('open', { default: false })
</script>

<template>
  <DialogRoot v-model:open="open">
    <DialogPortal>
      <DialogOverlay class="anim-overlay fixed inset-0 z-50 bg-black/50 lg:hidden" />
      <DialogContent class="anim-sheet fixed inset-y-0 left-0 z-50 flex w-72 flex-col border-r border-border bg-background p-3 outline-none lg:hidden">
        <DialogTitle class="sr-only">Navigation</DialogTitle>
        <div class="mb-4 flex h-12 items-center px-2"><Logo /></div>
        <NavList layout-key="mobile" />
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
